import { Injectable } from "@angular/core";
import { AlertController, IonicApp, Platform } from "ionic-angular";
import { CustomLoadingProvider } from "../custom-loading/custom-loading";
import { AChatroom } from "../../class/ana-chatroom";
import { BaseConfigProvider } from "../base-config/base-config";
import { HttpProvider } from "../http/http";
import { Observable } from "rxjs/Rx";
import { WxProvider } from "../wx/wx";
import { global } from "../../environments/global";
import { NotificationProvider } from "../notification/notification";

declare var wx: any;

// declare var QRCode: any;

/*
  Generated class for the UtilProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UtilProvider {
  public static DATE_NOW = Symbol();
  public static DATE_CURRENT = Symbol();
  public static DATE_10_DAYS_LATTER = Symbol();
  public static DATE_1_DAY_LATTER = Symbol();

  public sys_code;
  public wx = wx;
  can_download;

  constructor(public http: HttpProvider,
              public csLoader: CustomLoadingProvider,
              public plt: Platform,
              public NotificationService: NotificationProvider,
              public wxService: WxProvider) {
    this.http.getVipIdentity();
    console.log("Hello UtilProvider Provider");
    this.can_download = !this.plt.is("ios") || BaseConfigProvider.isPc();
    this.getUserLimit().subscribe(res => {
      this.userLimit = res;
    });
    if (BaseConfigProvider.is_weixin() && !BaseConfigProvider.isPc()) {
      this.getSign();
    }
  }

  /**
   * 统一的 goback 方法，如果不可pop 则直接跳往主页面*/
  public goBack(navCtrl) {
    // navCtrl.pop
    if (navCtrl.canGoBack()) {
      navCtrl.pop();
    } else {
      //outman test
      console.log("~~~~~~~~~~~~~~~~~~~~~~~~~cant go back");

      navCtrl.setRoot("NewHomePage");
    }
  }

  /**
   * 判断该对象是否为空
   */
  public isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (let key in obj) {
      if (this.hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }

  /**
   * 深拷贝
   */
  public deepClone(obj) {
    if (this.isEmpty(obj)) {
      return obj;
    }
    let _obj = JSON.stringify(obj),
      objClone = JSON.parse(_obj);
    return objClone;
  }

  public getSign() {
    this.wxService.getSignature().subscribe(res => {
      this.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: global.app_id, // 必填，公众号的唯一标识
        timestamp: res["content"]["timestamp"], // 必填，生成签名的时间戳
        nonceStr: res["content"]["noncestr"], // 必填，生成签名的随机串
        signature: res["content"]["signature"], // 必填，签名
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "onMenuShareQZone",
          "chooseImage",
          "uploadImage",
          "getLocalImgData",
          "downloadImage",
          "chooseWXPay"
        ] // 必填，需要使用的JS接口列表
      });
    });
  }

  /**
   *重写 nav push ,添加文件加载锁*/

  private is_loading_page_ts;

  public myNav(navCtrl: any, page, params?: any, opts?, done?) {
    if (!this.is_loading_page_ts) {
      this.is_loading_page_ts = true;
      navCtrl.push(page, params, opts, done).then(success => {
        this.is_loading_page_ts = false;
      }, err => {
        this.is_loading_page_ts = false;
      });
    }
  }

  /**
   * This kind of date string is adjoined with hyphen*/
  public getISODate(symbol: Symbol, date?: Date) {
    // return date.toLocaleDateString().replace(/\//g, '-');
    return this.getCustomDate(symbol, date)
      .toISOString()
      .split("T")[0];
  }

  /**
   * 获取特定的日期*/
  public getCustomDate(symbol: Symbol, date?: Date) {
    //一天的毫秒数
    const oneDayLong = 86400000;

    if (!date) date = new Date();

    switch (symbol) {
      case UtilProvider.DATE_NOW: {
        return new Date();
      }
      case UtilProvider.DATE_CURRENT: {
        return date;
      }
      case UtilProvider.DATE_1_DAY_LATTER: {
        let dateTemp = new Date(date.getTime() + oneDayLong);
        return dateTemp;
      }
      case UtilProvider.DATE_10_DAYS_LATTER: {
        let dateTemp = new Date(date.getTime() + oneDayLong * 10);
        return dateTemp;
      }
      default: {
        return date;
      }
    }
  }

  /**
   * 获取两天零点差的天数*/
  public getDateDiff(preDate: Date, nextDate: Date): number {
    let preUnix = this.getUnixByDate(new Date(this.getISODate(UtilProvider.DATE_CURRENT, preDate)));
    let nextUnix = this.getUnixByDate(new Date(this.getISODate(UtilProvider.DATE_CURRENT, nextDate)));
    return (nextUnix - preUnix) / 86400;
  }

  /**
   * 获取距离今天零点的天数*/
  public getTodayDateDiff(date: Date) {
    return this.getDateDiff(date, new Date());
  }

  /**
   * 普通提示信息框，仅仅提示信息*/
  public alertHintMsg(alertCtrl: AlertController, title: string, msg: string) {
    let alert = alertCtrl.create({
      title: title,
      message: msg,
      buttons: [
        {
          text: "好的",
          role: "cancel",
          handler: () => {
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * 可以取消的提示框*/
  public alertDeleteMsg(alertCtrl: AlertController, title: string, msg: string, confirmCallback) {
    let alert = alertCtrl.create({
      title: title,
      message: msg,
      buttons: [
        {
          text: "取消",
          role: "cancel",
          handler: () => {
          }
        },
        {
          text: "好的",
          handler: () => {
            confirmCallback();
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * 根据 url 生成二维码*/
  // public urlToQrcode(dom, url:string){
  //   // return typeof QRCode == 'undefined'?'1111':new QRCode(dom, url);
  //   return new QRCode(dom, url);
  // }

  /**
   * 获取 unix 时间戳，单位：秒*/
  public getUnixByDate(date: Date) {
    return new Date(date).getTime() / 1000;
  }

  /**
   * 获取 04-12 这种格式的string*/
  public getPartISO(date: Date) {
    let arr = this.getISODate(UtilProvider.DATE_CURRENT, date).split("-");
    return arr[1] + "/" + arr[2];
  }

  /**
   * 从群组中解出群列表*/
  public resolveChatroomFromGroup(groups) {
    let c_1 = [];
    for (let group of groups) {
      c_1 = c_1.concat(group.chatroom_list);
    }
    return c_1.filter(item => item.is_work == 1).map(item => new AChatroom(item));
  }

  /**
   * 处理后退不能消除modal 的问题*/
  public copeModal(ionicApp): boolean {
    let modal = ionicApp._modalPortal.getActive();
    if (modal) {
      modal.dismiss();
      return false;
    } else {
      return true;
    }
  }

  /**
   * 检测文件是否可以被预览*/
  public canPreview(fileName): boolean {
    let supportStr = "doc,docx,wps,odt,rtf,xls,xlsx,et,ods,csv,ppt,pptx,dps,odp,pdf,txt,zip,rar,tar,7z,mp3,m4a,mid,wma,html,htm,xml,js,css,java,php,sql";
    let supports = supportStr.split(",");
    for (let format of supports) {
      if (fileName.indexOf("." + format) > -1) {
        return true;
      }
    }
    return false;
  }

  /**
   * 预览文件*/
  public previewFile(url) {
    window.open("https://api.idocv.com/view/url?url=" + url);
  }

  userLimit;

  getUserLimit() {
    return this.userLimit ? Observable.of(this.userLimit) : this.http.hPost("/user/get_limit").map(res => res["content"]["limit_info"]);
  }

  /**
   * 可以换成全局获取的*/
  getChatroomList() {
    //TODO: change to whole
    return this.http.hPost("/group/get_group_list");
  }

  userBasicInfo;

  getBasicInfo() {
    return this.userBasicInfo ? Observable.of(this.userBasicInfo) : this.http.hPost("/user/get_user_basic_info").map(res => {
      this.userBasicInfo = res["content"];
      return this.userBasicInfo;
    });
  }

  updateCommonUsedModule(module) {
    let params = { "module": module };
    return this.http.hPost("/user/update_common_used_modules", params = params);
  }

  notificationList;

  getNotification() {
    return this.NotificationService.getNotiList().map(res => {
      this.notificationList = res["content"];
      return this.notificationList;
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/util/util.ts